import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#4F46E5", // indigo-600
    },
    secondary: {
      main: "#06B6D4", // cyan-500
    },
    background: {
      // modern soft canvas
      default: "#F3F5FF",
      paper: "#FFFFFF",
    },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: [
      "Inter",
      "system-ui",
      "-apple-system",
      "Segoe UI",
      "Roboto",
      "Arial",
      "sans-serif",
    ].join(","),
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#F3F5FF",
          backgroundImage:
            "radial-gradient(1200px 600px at 15% 0%, rgba(79, 70, 229, 0.10), transparent 60%), radial-gradient(1000px 500px at 85% 15%, rgba(6, 182, 212, 0.10), transparent 55%)",
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
        size: "medium",
      },
      styleOverrides: {
        root: {
          borderRadius: 12,
          minHeight: 40,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: "1px solid rgba(15, 23, 42, 0.08)",
          boxShadow:
            "0px 1px 2px rgba(15, 23, 42, 0.06), 0px 8px 24px rgba(15, 23, 42, 0.08)",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
        variant: "outlined",
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(15, 23, 42, 0.04)",
        },
      },
    },
  },
});

export default theme;
